var FexiosResponse = class {
	data;
	headers;
	ok;
	response;
	status;
	statusText;
	constructor(e, t) {
		this.data = e, this.headers = {}, this.ok = t.ok, this.response = { ...t }, this.status = t.status, this.statusText = t.statusText;
		for (let [e, n] of t.headers.entries()) this.headers[e] = Number.isNaN(Number(n)) ? n : Number(n);
	}
}, Fexios = class {
	#baseUrl = "";
	#headers = {};
	#isTextData = !1;
	#withCredentials = !1;
	constructor(e = {}) {
		this.#baseUrl = e.baseUrl || "", this.#headers = e.headers || {};
	}
	get credentials() {
		return this.#withCredentials = !0, this;
	}
	get text() {
		return this.#isTextData = !0, this;
	}
	async get(e, t) {
		return this.#getResponse(await fetch(this.#getUrl(e), this.#getOptions("GET", t)));
	}
	async post(e, t, n) {
		return this.#getResponse(await fetch(this.#getUrl(e), this.#getOptions("POST", n, t)));
	}
	async patch(e, t, n) {
		return this.#getResponse(await fetch(this.#getUrl(e), this.#getOptions("PATCH", n, t)));
	}
	async put(e, t, n) {
		return this.#getResponse(await fetch(this.#getUrl(e), this.#getOptions("PUT", n, t)));
	}
	async delete(e, t) {
		return this.#getResponse(await fetch(this.#getUrl(e), this.#getOptions("DELETE", t)));
	}
	#getOptions(e, t, n) {
		let r = {
			...t,
			headers: {
				"Content-Type": "application/json",
				...this.#headers,
				...t?.headers
			},
			method: e
		};
		return [
			"POST",
			"PUT",
			"PATCH"
		].includes(e) && (r.body = JSON.stringify(n ?? {})), this.#withCredentials && (r.credentials = "include"), r;
	}
	#reset() {
		this.#withCredentials = !1, this.#isTextData = !1;
	}
	async #getResponse(t) {
		let n = null;
		t.status !== 204 && (n = this.#isTextData ? await t.text() : await t.json());
		let r = new FexiosResponse(n, t);
		return this.#reset(), r;
	}
	#getUrl(e) {
		return e.startsWith("http://") || e.startsWith("https://") ? e : this.#baseUrl + e;
	}
};
export { Fexios };

//# sourceMappingURL=fexios.js.map